/**
 * ChartBarIcon — small "3 vertical bars" SVG used as a title prefix on
 * Penpot's data widgets (Invoices, Aging Report, Requests By Type,
 * Estimates, Repair Requests). Penpot palette: blue / green / amber.
 */

import * as React from "react";

export interface ChartBarIconProps {
  /** Total px size of the icon (default 14). */
  size?: number;
  className?: string;
}

export function ChartBarIcon({ size = 14, className = "" }: ChartBarIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden
    >
      <rect x="2" y="6.5" width="2" height="6" fill="#4b8df8" />
      <rect x="6" y="3.5" width="2" height="9" fill="#22c55e" />
      <rect x="10" y="8.5" width="2" height="4" fill="#f59e0b" />
    </svg>
  );
}
